import { render, staticRenderFns } from "./SejueDescription.vue?vue&type=template&id=4c7edf34&scoped=true&"
import script from "./SejueDescription.vue?vue&type=script&lang=js&"
export * from "./SejueDescription.vue?vue&type=script&lang=js&"
import style0 from "./SejueDescription.vue?vue&type=style&index=0&id=4c7edf34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7edf34",
  null
  
)

export default component.exports